module.exports = __webpack_public_path__ + "img/20190723145146719.b95a2cc5.png";